import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Unauthorized({ message, showBack = true }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const displayMessage = message || t('errors.unauthorized');

    return (
        <div className="unauthorized-container">
            <h1>{t('errors.accessDenied')}</h1>
            <p>{displayMessage}</p>
            {showBack && (
                <button type="button" className="btn btn-cancel" onClick={() => navigate(-1)}>
                    {t('common.back')}
                </button>
            )}
        </div>
    );
}

Unauthorized.propTypes = {
    message: PropTypes.string,
    showBack: PropTypes.bool,
};

export default Unauthorized;
